import React from "react";
import { Reveal } from "@/components/anim";
import { LEADERSHIP } from "@/data/content";

export default function Leadership() {
  return (
    <section id="leadership" data-testid="leadership-section" className="bg-bg-dark py-28 md:py-40">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <Reveal>
          <p className="text-brand-teal text-xs font-bold uppercase tracking-[0.25em] mb-4">Leadership</p>
          <h2 className="font-heading text-4xl md:text-6xl font-medium tracking-tight text-white leading-none max-w-3xl">
            A team built for execution.
          </h2>
          <p className="mt-6 max-w-2xl text-white/60 text-base md:text-lg leading-relaxed">
            Veterans of industrial infrastructure, project finance, and long-term operations — with more than 100 years
            of cumulative heavy-industry experience.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-px bg-white/10 border border-white/10">
          {LEADERSHIP.map((m, i) => (
            <Reveal key={m.name} delay={i * 0.06} className="bg-bg-dark">
              <div data-testid={`leader-${i}`} className="group relative overflow-hidden">
                <div className="aspect-[3/4] overflow-hidden bg-brand-navy/40">
                  <img
                    src={m.img}
                    alt={m.name}
                    className="h-full w-full object-cover object-top grayscale transition-all duration-700 group-hover:grayscale-0 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-bg-dark via-transparent to-transparent opacity-70" />
                </div>
                <div className="absolute bottom-0 left-0 p-5">
                  <h3 className="font-heading text-white text-lg leading-tight">{m.name}</h3>
                  <p className="text-brand-teal text-xs uppercase tracking-[0.15em] mt-1">{m.role}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
